/*
 * このソースコードはblanco Frameworkによって作成されました。
 */
import {
  RuleParamSchema,
  ValidationMessageTemplate,
  ValidationRuleFunction,
  ValidationRuleSchema,
} from "vee-validate/dist/types/types"

import { dateTimeEndValidator } from "./dateTimeEndValidator"
import { customMessage } from "./validatorUtil"

/**
 * VeeValidateのValidateRuleSchemaの実装クラスです。
 *
 * カスタムルール dateTimeEnd の定義です。
 */
export class DateTimeEndRuleSchema implements ValidationRuleSchema {
  validate: ValidationRuleFunction = (value, params) => {
    return dateTimeEndValidator(value, params)
  }
  params: RuleParamSchema[] = ["dateTimeEnd", "dateTimeEndErrorMessage"]
  message: ValidationMessageTemplate = (field: string, params?: Record<string, any>) => {
    return customMessage(field, params, ["dateTimeEnd", "dateTimeEndErrorMessage"])
  }
}
